import { useMutation } from '@tanstack/react-query';
import { useReducer } from 'react';
import { CLEAR_ERRORS } from 'src/context/types';
import { INITIAL_STATE } from 'src/core/constants/constants';
import { deviceDetect, isDesktop, isMobile } from 'react-device-detect';
import { generateFingerPrint } from 'src/utils/fingerPrint';
import { AuthReducer } from 'src/context/auth';
import { createUrl } from 'src/core/api/utils/createUrl';
import { fetch as fetchRedirect, takeContractId } from 'src/utils/refetch';

const useLoginMutation = () => {
  const [, dispatch] = useReducer(AuthReducer, INITIAL_STATE);

  const { mutate, isLoading, data, error } = useMutation({
    mutationFn: async (data: {
      code?: string,
      redirect_uri?: string,
      state?: string
      deleteSessions?: boolean
      pin?: string
    }) => {
      const clearErrors = () => dispatch({ type: CLEAR_ERRORS });
      let device;
      let device_type;

      if (isMobile) {
        device = deviceDetect(window.navigator.userAgent)?.model || 'Mobile';
        device_type = 'Mobile';
      } else if (isDesktop) {
        device = 'Desktop';
        device_type = 'Desktop';
      }
      let fingerprint = await generateFingerPrint();

      clearErrors();
      const { code, redirect_uri, state, pin, deleteSessions } = data;

      const payloadData = code ? {
        authorization_code: code,
        fingerprint: fingerprint,
        device_name: device,
        device_type,
        redirect_uri: redirect_uri,
        state: state,
        delete_sessions: deleteSessions || false,
      } : {
        pin: pin,
        contract_id: takeContractId(),
        fingerprint: fingerprint,
        device_name: device,
        device_type,
        delete_sessions: deleteSessions || false,
        username: localStorage.getItem('username') || '',
      };

      const headers = code ? {} : {
        'sky-token': localStorage.getItem('sky_token'),
        'sky-refresh-token': localStorage.getItem('sky_refresh_token') || '',
      };


      const response = await fetchRedirect(createUrl(`/login? `), {
        method: 'POST',
        body: JSON.stringify(payloadData),
        headers: headers,
      });

      if (!response.response.ok) {
        return response.body;
      }
      return response.body;
    },
  });

  return { mutate, isLoading, data, error };
};

export default useLoginMutation;
